export enum SubscriptionStatus {
    TERMINATED = "terminated",
    ACTIVE = "active",
    NEW = "new",
    IDLE = "idle",
    LIMITED = "limited",
    SUSPENDED = "suspended",
}